var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjTension(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.009 -0.342)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    transform: "translate(0.009 0.342)",
    fill: "#394F65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.953,91.541a6.651,6.651,0,0,0-2.479-4.312,5.348,5.348,0,0,0-6.509-.048,4.984,4.984,0,0,0-1.458,1.7,4.982,4.982,0,0,0-1.458-1.7,5.345,5.345,0,0,0-6.509.048,6.651,6.651,0,0,0-2.479,4.312,7.13,7.13,0,0,0,.078,2.476.51.51,0,1,0,1-.21,6.021,6.021,0,0,1-.12-1.242,6.114,6.114,0,0,1,.064-.876,5.626,5.626,0,0,1,2.09-3.638,4.334,4.334,0,0,1,5.277-.042,3.884,3.884,0,0,1,1.3,1.648c.025.062.042.112.059.162a.758.758,0,0,0,1.424,0c.017-.045.034-.1.059-.157a3.884,3.884,0,0,1,1.3-1.651,4.334,4.334,0,0,1,5.277.042,5.626,5.626,0,0,1,2.09,3.638,6.094,6.094,0,0,1,.064.876,5.792,5.792,0,0,1-1.634,4.06l-.257.26c-.448.453-.912.921-1.357,1.4l-5.342,5.675-.036.042h0a1.089,1.089,0,0,1-.862.459h-.048a1.089,1.089,0,0,1-.865-.45l-.036-.042L172.5,99.614a.51.51,0,1,0-.744.7l4.068,4.332a2.1,2.1,0,0,0,1.662.84h.05a2.1,2.1,0,0,0,1.662-.84l5.333-5.669c.436-.465.9-.929,1.338-1.377l.257-.26a6.82,6.82,0,0,0,1.9-4.771,7.11,7.11,0,0,0-.073-1.024Z",
    transform: "translate(-154.768 -72.679)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.252,194.363h.213l.039-.02h.014l.025-.014h.014l.022-.017.025-.022.028-.031h0a.509.509,0,0,0,.053-.079v-.1l.82-3.078,1.119,6.495v.137l.017.028.019.025.02.022v.014l.02.017.017.014.022.017.031.022h.112l.067.017h.241l.034-.017.23-.05.025-.014h.017l.022-.017h.014l.025-.022a.5.5,0,0,0,.062-.07l.02-.031.014-.028V197.5l1.4-4.511.364,1.066a.533.533,0,0,0,.031.067.507.507,0,0,0,.039.059l.045.05.048.039.059.036.064.025.067.017h2.678a.509.509,0,0,0,0-1.018h-2.239l-.747-2.194a.509.509,0,0,0-.929-.081v.019a.517.517,0,0,0-.037.084l-1.156,3.993-1.17-6.716v-.165l-.014-.022v-.02l-.1-.022v-.022l-.014-.014-.022-.02-.025-.02h-.014l-.025-.017h-.524l-.025.017h-.017l-.022.017-.053.053v.017l-.017.022v.017l-.017.025v.117l-1.315,4.945H112.51a.509.509,0,1,0,0,1.018h8.742Z",
    transform: "translate(-101.633 -169.575)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjTension);
export default __webpack_public_path__ + "static/media/OBJ-TENSION.2aaecc8e25fde02a660c19c59783d9f9.svg";
export { ForwardRef as ReactComponent };